export default __webpack_public_path__ + "assets/TKO-operate.418c45fd.gif";